export enum AffiliateSaleStatus {
  UNPAID = 'UNPAID',
  PAID = 'PAID',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
}
